import { Stack, Tab, Typography } from "@mui/material";

export const ResourceDetailsHeaderCoverageTab = (coverage?: number) => (
  <Tab
    sx={{ textTransform: "none" }}
    disabled={!coverage}
    label={
      <Stack direction="row" alignItems="center">
        <Typography variant="inherit">Coverage</Typography>

        <Stack
          ml={1}
          p={0.5}
          px={1}
          borderRadius={10}
          justifyContent="center"
          bgcolor={coverage ? "primary.light" : "grey.200"}
        >
          <Typography variant="inherit" fontSize={12}>
            {coverage ?? 0}%
          </Typography>
        </Stack>
      </Stack>
    }
    value="coverage"
  />
);
